import { Component } from "@angular/core";
import { BaseComponent } from "./base.component";

@Component({
	template: "",
})
export class BaseListComponent extends BaseComponent {
	protected collection: string;
	protected populate: string;
	protected columns: any;
	protected dataLoading: boolean;
	protected sortField: string;
	protected sortOrder: "asc" | "desc";
	protected filters: any;
	protected pageCurrent: number = 0;
	protected pageSize: number = 20;
	protected pageTotal: number;
	protected isDataLoading: boolean = false;

	constructor() {
		super();
	}
}
